import { z } from 'zod';
const entityTypeEnum = z.enum(['call', 'conversation']).default('call');
/** Query schema for all QA feedback entries with filtering */
export const getQAFeedbackSchema = z.object({
    // Pagination
    page_id: z.string()
        .regex(/^\d+$/, 'page_id must be a number')
        .default('0')
        .transform((v) => parseInt(v, 10))
        .refine((v) => v >= 0, 'page_id must be 0 or greater'),
    page_size: z.string()
        .regex(/^\d+$/, 'page_size must be a number')
        .default('50')
        .transform((v) => parseInt(v, 10))
        .refine((v) => v > 0 && v <= 100, 'page_size must be between 1 and 100'),
    // Sorting
    order_by: z.enum(['created_time', 'customer', 'status', 'category']).default('created_time'),
    order_type: z.enum(['asc', 'desc']).default('desc'),
    // Filters
    status: z.string().optional(),
    category: z.string().optional(),
    time_filter: z.enum(['today', 'week']).optional(),
    campaign_id: z.string()
        .regex(/^\d+$/, 'campaign_id must be a number')
        .transform((v) => parseInt(v, 10))
        .optional(),
    entity_type: entityTypeEnum.optional(),
});
/** Schema for creating feedback */
export const crateQAFeedbackSchema = z.object({
    entity_id: z.string().min(1, 'entity_id is required'),
    entity_type: entityTypeEnum,
    feedback: z.object({
        entity_id: z.string().min(1, 'entity_id is required'),
        status: z.string(),
        category: z.string(),
    }),
    comment: z.object({
        entity_id: z.string().min(1, 'entity_id is required'),
        message: z.string().min(1, 'message is required'),
    })
});
/** Schema for updating feedback */
export const updateQAFeedbackSchema = z.object({
    entity_id: z.string().min(1, 'entity_id is required'),
    entity_type: entityTypeEnum,
    status: z.string(),
    category: z.string(),
});
/** Schema for adding comment */
export const addQACommentSchema = z.object({
    entity_id: z.string().min(1, 'entity_id is required'),
    entity_type: entityTypeEnum,
    message: z.string().min(1, 'message is required'),
});
/** Schema for updating comment */
export const updateQACommentSchema = z.object({
    entity_id: z.string().min(1, 'entity_id is required'),
    entity_type: entityTypeEnum,
    comment_id: z.coerce.number().int().positive(),
    message: z.string().min(1, 'message is required'),
});
